export const getUser = (state) => state.user
export const getUserRole = (state) => state.user ? state.user.role : null
export const getIsUserAdmin = (state) => state.user ? state.user.is_admin : null
export const getIsUserManagement = (state) => state.user ? state.user.is_management : null
export const isAuthenticated = (state) => !!state.token
export const getPlan = (state) => state.user ? state.user.plan : null
export const getBillingInfo = (state) => state.user ? state.user.billing_info : null